import { Reveal } from "./Reveal";
import { motion } from "framer-motion";

const CHAPTERS = [
  {
    number: "01",
    title: "PRECISION AT 300 KM/H",
    description:
      "High-velocity tracking demands specialized arm vehicles and optical precision. We match the pace of the track.",
  },
  {
    number: "02",
    title: "THE SILENT TENSION",
    description:
      "Motorsport is not just raw engine sound; it is the quiet intensity in the pits before the green light.",
  },
  {
    number: "03",
    title: "CRAFTED FOR BIG SCREENS",
    description:
      "Every frame is color-graded with filmic grain, custom LUTs, and dynamic spatial audio design.",
  },
  {
    number: "04",
    title: "NO RE-TAKES IN RACING",
    description:
      "You get one chance to capture the decisive overtake. Our crew operates with military synchronization.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative bg-surface py-24 md:py-36"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-mono text-[10px] tracking-[0.4em] text-signal mb-4">04 — MANIFESTO</p>
          <h2
            className="font-display text-5xl md:text-7xl text-white leading-[0.95] mb-16 md:mb-24"
            style={{ fontWeight: 900 }}
          >
            HOW WE <span className="text-outline">SHOOT</span>
          </h2>
        </Reveal>

        <div>
          {CHAPTERS.map((ch, i) => (
            <Reveal key={ch.number} delay={i * 0.05}>
              <div
                data-testid={`manifesto-chapter-${ch.number}`}
                className="group relative border-t border-white/10 last:border-b py-10 md:py-14 grid grid-cols-12 items-start gap-4 md:gap-8 hover:bg-white/[0.02] transition-colors duration-500"
              >
                <div className="absolute left-0 top-0 h-full w-[2px] bg-signal scale-y-0 group-hover:scale-y-100 origin-top transition-transform duration-500" />
                <span className="col-span-2 md:col-span-1 font-mono text-signal text-sm md:text-base pt-2 md:pl-6">
                  {ch.number}
                </span>
                <h3
                  className="col-span-10 md:col-span-5 font-display text-3xl md:text-5xl text-white group-hover:translate-x-2 transition-transform duration-500"
                  style={{ fontWeight: 800 }}
                >
                  {ch.title}
                </h3>
                <p className="col-span-12 md:col-span-5 md:col-start-8 text-smoke text-sm md:text-base font-light leading-relaxed md:pl-6">
                  {ch.description}
                </p>
                <motion.span className="hidden md:block absolute right-6 top-1/2 -translate-y-1/2 font-mono text-xs text-signal opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  →
                </motion.span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
